import store from '@/store';
import { leaseType,repaymentMethodList } from '@/util/dictList.js'
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  editBtn: false,
  editBtnText: '修改',
  delBtn: false,
  editTitle: '修改',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: true,
  indexLabel: '序号',
  selection: true,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  rowKey: 'index',
  column: [
    {
      label: '平台',
      prop: 'platformId',
      type: 'select',
      search: true,
      display: false,
      hide:true,
      span: 24,
      dicData: [],
      props: {
        label: "platformName",
        value: "id",
      },
    },
    {
      label: '平台',
      prop: 'platformName',
      type: 'input',
      search: false,
      span: 24,
      addDisplay: true,
      editDisabled: true,
      editDisplay: true,
      searchPlaceholder: '请输入平台',
      maxlength: 50,
      rules: [
        {
          required: true,
          message: '请输入平台',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '平台利率',
      prop: 'platformRateString',
      type: 'select',
      display: false,
      search: true,
      hide: true,
      span: 24,
      dicData: [],
      props: {
        label: "lable",
        value: "platformRate",
      },
    },
    {
      label: '平台利率',
      prop: 'platformRate',
      search: false,
      editDisplay: true,
      addDisplay: true,
      span: 24,
      append: '%',
      formatter: (val, value, label) => {
        return value ? value + '%' : '';
      },
      rules: [
        {
          required: true,
          message: '请输入平台利率',
          trigger: 'blur',
        },
        {
          pattern: /^(?:0(?:\.\d{1,2})?|[1-9]\d?(?:\.\d{1,2})?|100?)$/,
          message: '利率只能在0-100之间，允许输入两位小数',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '还款方式',
      prop: 'repaymentMethod',
      type: 'select',
      span: 24,
      addDisplay: true,
      editDisplay: true,
      search: true,
      showColumn: false,
      dicData: repaymentMethodList,
      rules: [
        {
          required: true,
          message: '请选择还款方式',
          trigger: 'blur',
        },
      ],
    },
    // {
    //   label: '还款期数',
    //   prop: 'repayment',
    //   editDisplay: true,
    //   type: 'select',
    //   span: 24,
    //   search: true,
    //   addDisplay: true,
    //   showColumn: false,
    //   dicData: leaseType,
    //   rules: [
    //     {
    //       required: true,
    //       message: '请选择还款期数',
    //       trigger: 'blur',
    //     },
    //   ],
    // },

    {
      label: 'id',
      prop: 'id',
      display: false,
      hide: true,
    },

    {
      label: '是否禁用',
      prop: 'status',
      type: 'radio',
      slot: true,
      formslot: true,
      search: false,
      width: 100,
      display: false,
      dicData: [
        {
          label: '是',
          value: 0,
        },
        {
          label: '否',
          value: 1,
        },
      ],
    },
  ],
};
